/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Status_LabelInputs */

const en_us2_bodymap_status_label = /** @type {(inputs: Bodymap_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where did it get to?`)
};

const pt_br2_bodymap_status_label = /** @type {(inputs: Bodymap_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como está hoje?`)
};

const es_419_bodymap_status_label = /** @type {(inputs: Bodymap_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo está hoy?`)
};

const pt_pt2_bodymap_status_label = /** @type {(inputs: Bodymap_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como está hoje?`)
};

const fr_fr2_bodymap_status_label = /** @type {(inputs: Bodymap_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Où en es-tu aujourd'hui ?`)
};

const de_de2_bodymap_status_label = /** @type {(inputs: Bodymap_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie ist es heute?`)
};

const it_it2_bodymap_status_label = /** @type {(inputs: Bodymap_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com'è oggi?`)
};

/**
* | output |
* | --- |
* | "Where did it get to?" |
*
* @param {Bodymap_Status_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_status_label = /** @type {((inputs?: Bodymap_Status_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Status_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_status_label(inputs)
	if (locale === "es-419") return es_419_bodymap_status_label(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_status_label(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_status_label(inputs)
	if (locale === "de-DE") return de_de2_bodymap_status_label(inputs)
	if (locale === "it-IT") return it_it2_bodymap_status_label(inputs)
	return en_us2_bodymap_status_label(inputs)
});
export { bodymap_status_label as "bodymap.status.label" }